import { alpha } from '@mui/system';
import { themeObject } from '../../lib';

export const CHATBOT = {
    PAGE_TITLE: 'Ask Blast',
    SEARCH_FIELD_PLACEHOLDER: 'Ask a question',
    CHAT_BUTTON_LABEL: 'Ask Blast',
    INITIAL_CHAT_TITLE: 'How can I help?',
    INITIAL_CHAT_DESCRIPTION:
        'Hi, I’m Blast. I’m your personal assistant for all things LifeGraph. You can ask me your own question or try one of the prompts below. I’m still in training, so please ask detailed questions for more accurate responses.',
    NEW_CONVERSATION_LINK_LABEL: '+ New Conversation',
    DATA_PROTECTION_LINK_LABEL: 'How we protect your data',
};

export const questionPrompts = [
    'What is a LifeGraph?',
    'What is a Consent Contract?',
    'What is TQL?',
];

export const BLAST_AI_CONVERSATION: string = 'blastAIConversation';

export type MessageType = 'user' | 'blast' | 'pending' | 'error';

export interface ChatMessage {
    type: MessageType;
    title?: string;
    value: string;
}

export const blastMainStyles = {
    pageContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
    },
    titleAndAddButtonContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 2.5,
        mx: 3.875,
        mt: 3,
    },
    titleContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    headingText: {
        ...themeObject.typography.titleCopy,
        color: themeObject.palette.primary[700],
        mr: '10px',
    },
    bodyContainer: {
        display: 'flex',
        flexDirection: 'row',
        height: 'calc(100vh - 218px)',
        mb: 7.375,
        mx: 6.625,
        justifyContent: 'space-evenly',
        alignItems: 'center',
    },
    imageContainer: {
        ml: 3.375,
        alignContent: 'center',
        height: '100%',
        maxHeight: '100%',
    },
    initialChatTitleText: {
        ...themeObject.typography.banner.bannerMobile,
        color: themeObject.palette.primary[700],
        textAlign: 'center',
        pb: 2,
    },
    initialChatDescriptionText: {
        ...themeObject.typography.body1,
        color: themeObject.palette.grayScale[800],
        textAlign: 'center',
        mb: '12px',
    },
    questionPromptMainContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
    },
    questionPromptContainerStyles: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        my: 0.5,
        p: '8px 16px',
        borderRadius: '10px',
        backgroundColor: themeObject.palette.background.default,
        boxShadow: `0px 0px 3px 0px ${alpha(
            themeObject.palette.grayScale[700],
            0.2
        )},0px 1px 1px 0px ${alpha(
            themeObject.palette.grayScale[700],
            0.22
        )},0px 2px 1px -1px ${alpha(themeObject.palette.grayScale[700], 0.2)}`,
    },
    questionPromptTextStyles: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.regular,
        lineHeight: '100%',
        color: themeObject.palette.grayScale[800],
        ml: 2,
    },
};
